var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      attrs: {
        "grid-list-xl": "",
        "text-center": "",
        role: "region",
        "aria-label": "Change password section",
      },
    },
    [
      _c(
        "v-layout",
        { attrs: { wrap: "" } },
        [
          _c(
            "v-flex",
            {
              attrs: {
                xs12: "",
                sm12: "",
                md12: "",
                lg6: "",
                "offset-lg3": "",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    {
                      attrs: {
                        flat: "",
                        color: "primary",
                        role: "heading",
                        "aria-level": "1",
                      },
                    },
                    [
                      _c("v-toolbar-title", { staticClass: "text-body-2" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("components.changePassword.title")) +
                            "\n          "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-container",
                    { attrs: { fluid: "", "grid-list-md": "" } },
                    [
                      _vm._l(
                        _vm.filteredErrors,
                        function (errorsGroup, errorsGroupIndex) {
                          return _c(
                            "div",
                            {
                              key: errorsGroupIndex,
                              attrs: { role: "alert", "aria-live": "polite" },
                            },
                            _vm._l(errorsGroup, function (error) {
                              return _c(
                                "v-alert",
                                {
                                  key: error.id,
                                  attrs: { type: error.type, icon: error.icon },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(error.msg) +
                                      "\n            "
                                  ),
                                ]
                              )
                            }),
                            1
                          )
                        }
                      ),
                      _vm._v(" "),
                      _c(
                        "v-form",
                        {
                          attrs: { "aria-describedby": "change-password-form" },
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return _vm.validate($event)
                            },
                          },
                        },
                        [
                          _c(
                            "v-layout",
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required|min:6|max:50",
                                        expression: "'required|min:6|max:50'",
                                      },
                                    ],
                                    attrs: {
                                      "prepend-icon": "fal fa-key",
                                      color: "accent",
                                      autocomplete: "current-password",
                                      "data-vv-as": "current password",
                                      "data-vv-name": "currentPassword",
                                      "error-messages":
                                        _vm.errors.collect("currentPassword"),
                                      label: _vm.$t(
                                        "components.changePassword.form.currentPass"
                                      ),
                                      name: "currentPassword",
                                      type: "password",
                                      "aria-required": "true",
                                      "aria-label": "Current password",
                                    },
                                    model: {
                                      value: _vm.form.currentPassword,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "currentPassword",
                                          $$v
                                        )
                                      },
                                      expression: "form.currentPassword",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required|min:6|max:50",
                                        expression: "'required|min:6|max:50'",
                                      },
                                    ],
                                    ref: "newPassword",
                                    attrs: {
                                      "prepend-icon": "fal fa-key",
                                      color: "accent",
                                      autocomplete: "new-password",
                                      "data-vv-as": "new password",
                                      "data-vv-name": "newPassword",
                                      "error-messages":
                                        _vm.errors.collect("newPassword"),
                                      label: _vm.$t(
                                        "components.changePassword.form.password"
                                      ),
                                      name: "newPassword",
                                      type: "password",
                                      "aria-required": "true",
                                      "aria-label": "New password",
                                    },
                                    model: {
                                      value: _vm.form.newPassword,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "newPassword", $$v)
                                      },
                                      expression: "form.newPassword",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value:
                                          "required|min:6|max:50|confirmed:newPassword",
                                        expression:
                                          "'required|min:6|max:50|confirmed:newPassword'",
                                      },
                                    ],
                                    attrs: {
                                      "prepend-icon": "fal fa-key",
                                      color: "accent",
                                      autocomplete: "new-password",
                                      "data-vv-as":
                                        "confirmation of new password",
                                      "data-vv-name": "confirmNewPassword",
                                      "error-messages":
                                        _vm.errors.collect(
                                          "confirmNewPassword"
                                        ),
                                      label: _vm.$t(
                                        "components.changePassword.form.confirmPass"
                                      ),
                                      name: "confirmNewPassword",
                                      type: "password",
                                      "aria-required": "true",
                                      "aria-label": "Confirm new password",
                                    },
                                    model: {
                                      value: _vm.form.confirmNewPassword,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "confirmNewPassword",
                                          $$v
                                        )
                                      },
                                      expression: "form.confirmNewPassword",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-progress-linear", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isLoading,
                                expression: "isLoading",
                              },
                            ],
                            attrs: {
                              color: "accent",
                              indeterminate: "",
                              role: "progressbar",
                              "aria-label": "Submitting form",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                "aria-label": _vm.$t(
                                  "components.changePassword.buttons.change"
                                ),
                                color: "accent",
                                type: "submit",
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "components.changePassword.buttons.change"
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }